import { computed, inject, Injectable, signal } from '@angular/core';
import { BusinessRouter } from './business-router';

@Injectable({ providedIn: 'root' })
export class MeetingRouter {
  private readonly businessRouter = inject(BusinessRouter);
  private scope: 'meetings' | 'points' = 'meetings';
  private readonly ids = signal<number[]>([]);
  private readonly currentId = signal<number>(-1);
  private readonly currentIndex = computed<number>(() => this.ids().findIndex((id) => id === this.currentId()));
  public readonly hasNextElement = computed<boolean>(() => {
    const ids = this.ids();
    const currentId = this.currentId();

    if (!ids.length) return false;

    if (!currentId) return false;

    const currentIndex = this.currentIndex();

    if (currentIndex === -1) return false;

    const nextElement = ids[currentIndex + 1];

    return !!nextElement;
  });
  public readonly hasPreviousElement = computed<boolean>(() => {
    const ids = this.ids();
    const currentId = this.currentId();

    if (!ids.length) return false;

    if (!currentId) return false;

    const currentIndex = this.currentIndex();

    if (currentIndex === -1) return false;

    const previousElement = ids[currentIndex - 1];

    return !!previousElement;
  });

  public setScope(scope: 'meetings' | 'points'): void {
    this.scope = scope;
  }

  public setIdsList(ids: number[]): void {
    this.ids.set(ids);
  }

  public setCurrentId(id: number): void {
    this.currentId.set(id);
  }

  public setConfig(config: { currentId: number; scope: 'meetings' | 'points'; ids: number[] }): void {
    const { currentId, scope, ids } = config;

    this.setIdsList(ids);
    this.setCurrentId(currentId);
    this.setScope(scope);
  }

  public goToNext(): void {
    const ids = this.ids();
    const currentIndex = this.currentIndex();

    if (currentIndex === -1) return;

    if (!this.hasNextElement()) return;

    const nextId = ids[this.currentIndex() + 1];

    if (!nextId) return;

    this.currentId.set(nextId);

    this.go();
  }

  private go(): void {
    if (this.scope === 'meetings') this.businessRouter.goToAMeeting(this.currentId());
    else this.businessRouter.goToAPoint(this.currentId());
  }

  public goToPrevious(): void {
    const ids = this.ids();
    const currentIndex = this.currentIndex();

    if (currentIndex === -1) return;

    if (!this.hasPreviousElement()) return;

    const previousId = ids[this.currentIndex() - 1];

    if (!previousId) return;

    this.currentId.set(previousId);

    this.go();
  }
}
